import { render, staticRenderFns } from "./ScatterPlot.vue?vue&type=template&id=986b894c&scoped=true&"
import script from "./ScatterPlot.vue?vue&type=script&lang=js&"
export * from "./ScatterPlot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "986b894c",
  null
  
)

export default component.exports